import axios from 'axios'

export const authAxios = axios.create({
  headers: {
    Authorization: 'Basic d2VidXNlcjpIZzZ0cjQxLWJHNjRuJF9KSzgvajc='
  }
})
